// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"636":"eb197dfcf8e7b558","7414":"260f728284d2fef3"}[chunkId] + ".css";
};